import { render, staticRenderFns } from "./unpaidOrderList.vue?vue&type=template&id=9bdee6dc&scoped=true&"
import script from "./unpaidOrderList.vue?vue&type=script&lang=js&"
export * from "./unpaidOrderList.vue?vue&type=script&lang=js&"
import style0 from "./unpaidOrderList.vue?vue&type=style&index=0&id=9bdee6dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bdee6dc",
  null
  
)

export default component.exports